(() => {
  if (window.__LK_UPSELL_ADD_INIT__) return;
  window.__LK_UPSELL_ADD_INIT__ = true;

  // These filenames match what your cart-drawer section returns in HTML.
  // If your theme uses different names, change them here.
  const ASSETS = {
    css: [
      "{{ 'quantity-popover.css' | asset_url }}",
      "{{ 'component-card.css' | asset_url }}"
    ],
    js: [
      "{{ 'cart.js' | asset_url }}",
      "{{ 'quantity-popover.js' | asset_url }}"
    ]
  };

  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function alreadyLoaded(tag, url) {
    return [...document.querySelectorAll(tag)].some(el =>
      (el.getAttribute('src') || el.getAttribute('href')) === url
    );
  }

  function loadCssOnce(href) {
    if (!href || alreadyLoaded('link[rel="stylesheet"]', href)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function loadScriptOnce(src) {
    return new Promise((resolve, reject) => {
      if (!src) return resolve();
      if (alreadyLoaded('script', src)) return resolve();

      const s = document.createElement('script');
      s.src = src;
      s.defer = true;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error('Failed to load script: ' + src));
      document.head.appendChild(s);
    });
  }

  async function ensureCartDrawerAssets() {
    // If cart-drawer is already defined, we’re good.
    if (customElements.get('cart-drawer')) return;

    // Load CSS first (safe even if not needed)
    ASSETS.css.forEach(loadCssOnce);

    // Load JS (must execute to define <cart-drawer> + make drawer visible)
    for (const src of ASSETS.js) {
      await loadScriptOnce(src);
    }

    // Wait until the custom element upgrades
    try {
      await customElements.whenDefined('cart-drawer');
    } catch (_) {}
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function stripLinksAndScriptsFromSection(sectionOuterHTML) {
    const doc = parseHTML(sectionOuterHTML);
    const wrapper =
      doc.querySelector('#shopify-section-cart-drawer') ||
      doc.querySelector('#shopify-section-cart-icon-bubble');
    if (!wrapper) return sectionOuterHTML;

    wrapper.querySelectorAll('script, link[rel="stylesheet"]').forEach(n => n.remove());
    return wrapper.outerHTML;
  }

  function replaceSectionById(sectionName, sectionHTML) {
    const id = `#shopify-section-${sectionName}`;
    const current = document.querySelector(id);
    if (!current) return false;

    const clean = stripLinksAndScriptsFromSection(sectionHTML);
    const doc = parseHTML(clean);
    const incoming = doc.querySelector(id);
    if (!incoming) return false;

    current.replaceWith(incoming);
    return true;
  }

  function openDrawerSafely() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    return false;
  }

  function getMainProductSectionId() {
    const input = document.querySelector('input[name="section-id"]');
    return input && input.value ? input.value : null;
  }

  async function addToCartAndUpdateUI({ variantId, productId, addToCartUrl }) {
    const fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', '1');

    // Request sections HTML (this is what makes Shopify return "sections": {...})
    fd.append('sections', SECTIONS.join(','));
    fd.append('sections_url', window.location.pathname + window.location.search);

    // These often exist on product page add-to-cart; helps Shopify match correct section context
    const sectionId = getMainProductSectionId();
    if (sectionId) fd.append('section-id', sectionId);
    if (productId) fd.append('product-id', String(productId));

    fd.append('form_type', 'product');
    fd.append('utf8', '✓');

    const res = await fetch(addToCartUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: fd
    });

    const text = await res.text();
    let data;
    try { data = JSON.parse(text); } catch { throw new Error(text); }
    if (!res.ok) throw new Error(text);

    // 1) Ensure cart drawer code exists BEFORE we try to open / render
    await ensureCartDrawerAssets();

    // 2) Preferred: let the theme component render itself (most stable)
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(data);
    } else if (data.sections) {
      // 3) Fallback: replace sections manually (strip scripts/links)
      if (data.sections['cart-drawer']) {
        replaceSectionById('cart-drawer', data.sections['cart-drawer']);
      }
      if (data.sections['cart-icon-bubble']) {
        replaceSectionById('cart-icon-bubble', data.sections['cart-icon-bubble']);
      }
    }

    // 4) Open after DOM has settled
    requestAnimationFrame(() => {
      // re-query in case DOM changed
      openDrawerSafely();
    });

    return data;
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-lk-add]');
    if (!btn) return;

    const variantId = Number(btn.getAttribute('data-variant-id'));
    const productIdAttr = btn.getAttribute('data-product-id');
    const productId = productIdAttr ? Number(productIdAttr) : null;
    const addToCartUrl = btn.getAttribute('data-cart-add-url');

    if (!variantId || btn.disabled) return;

    e.preventDefault();
    btn.disabled = true;

    try {
      await addToCartAndUpdateUI({ variantId, productId, addToCartUrl });
    } catch (err) {
      console.error('[LK_UPSELL] add failed:', err);
      alert('Could not add to cart.');
    } finally {
      btn.disabled = false;
    }
  });
})();
